// global variables for the app
export enum CompanyCodes {
    SWIFT = 'swift',
    KNIGHT = 'knight',
}
